import Button from "../../Button/Button";
import FullScreenMobilePage from "../../FullScreenMobilePage/FullScreenMobilePage";
import legalInfo from "../../../assets/images/illustrations/biometrics-legal-info.png";
import styles from "./LegalInfo.module.scss";
import { useAppDispatch } from "../../../store/hooks";
import {
  biometricsOptInPage,
  setBiometricInProgress,
} from "../../../store/slices/authSlice";

interface Props {
  handleBiometricAccept: () => void;
}

const LegalInfo = ({ handleBiometricAccept }: Props) => {
  const { footer, content } = styles;

  const dispatch = useAppDispatch();

  return (
    <FullScreenMobilePage
      headerContent="Ingreso con factor biométrico"
      footerContent={
        <section className={footer}>
          <Button
            variant="primary"
            text="Activar"
            onPress={() => handleBiometricAccept()}
          />
          <Button
            variant="secondary"
            text="Continuar sin factor"
            onPress={() => {
              dispatch(setBiometricInProgress(false));
              dispatch(biometricsOptInPage("REFUSE_BIOMETRICS"));
            }}
          />
        </section>
      }
    >
      <div className={content}>
        <section>
          <article>
            <h2>¿Qué es el ingreso con factor biométrico?</h2>
            <p>
              Es un método de ingreso rápido y seguro que te permite acceder a
              tu cuenta sin tener que escribir tu mail y contraseña cada vez que
              uses la aplicación.
            </p>
          </article>
          <article>
            <h2>¿Cómo funciona?</h2>
            <p>
              Al activarlo, cuando abras la aplicación vamos a identificarte con
              tu reconocimiento facial, según como tengas configurado el
              desbloqueo de tu celular.
            </p>
            <img src={legalInfo} alt="Ilustración de biometría" />
          </article>
          <article>
            <h2>¿Cómo lo desactivo?</h2>
            <p>
              Podes hacerlo desde el inicio de la aplicación, desactivando el
              botón de “Ingresar con factor biométrico” o desde “Gestión de
              usuarios”.{" "}
            </p>
            <p>
              De esta forma podés ingresar con tu mail y contraseña de Allaria
              como siempre.
            </p>
          </article>
        </section>
        <section>
          <p>
            Al activar el ingreso rápido sos responsable de adoptar todas las
            precauciones y medidas de seguridad pertinentes para impedir su uso
            por otras personas o en condiciones no autorizadas.{" "}
          </p>
          <p>
            Tus datos biométricos o tu PIN permanecen en tus dispositivos y
            Allaria no puede acceder a ellos.
          </p>
        </section>
      </div>
    </FullScreenMobilePage>
  );
};

export default LegalInfo;
